import { render, staticRenderFns } from "./DeviceDetailStandardConfiguration.vue?vue&type=template&id=186293ca&scoped=true&"
import script from "./DeviceDetailStandardConfiguration.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailStandardConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetailStandardConfiguration.vue?vue&type=style&index=0&id=186293ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186293ca",
  null
  
)

export default component.exports